import {getDayOfWeek, isLocationCurrentlyOpen, getOpenTime, getCloseTime} from '@/Utils';

const dayOfWeek = getDayOfWeek();
const locationCards = document.querySelectorAll('.location-card');

locationCards.forEach(function(card) {
	const id = card.dataset.retailerId;
	const retailer = dutchie.retailers.find(function(retailer) {
		return retailer.id == id;
	});

	if (!retailer.hours) {
		return;
	}
	
	const todaysHours = retailer.hours.pickup[dayOfWeek];
	const isOpen = isLocationCurrentlyOpen( todaysHours );
	const opensAt = getOpenTime( todaysHours);
	const closesAt = getCloseTime( todaysHours);

	if ( retailer && isOpen ) {
		const isOpenDiv = card.querySelector('.is-open');
		isOpenDiv.style.display = 'block';
		const closesAtDiv = card.querySelector('.closes-at');
		if ( closesAt ) {
			closesAtDiv.innerHTML = closesAt;
		}
	} else if ( retailer && !isOpen ) {
		const isClosedDiv = card.querySelector('.is-closed');
		isClosedDiv.style.display = 'block';
		const opensAtDiv = card.querySelector('.opens-at');
		if ( opensAt) {
			opensAtDiv.innerHTML = opensAt;
		}
	}
});

const stateButtons = document.querySelectorAll('.state-buttons button');

stateButtons.forEach(function(button) {
	button.addEventListener('click', function() {
		stateButtons.forEach(function(btn) {
            btn.classList.remove('active');
        });
		const state = button.dataset.state;
		button.classList.add('active');
		const locationCards = document.querySelectorAll('.location-card');
		
		if ( state === 'all' ) {
			locationCards.forEach(function(card) {
				card.style.display = 'flex';
			});
			return;
		}

		locationCards.forEach(function(card) {
			const cardState = card.dataset.state;
			const cardComingSoon = card.dataset.comingSoon;

			if ( cardState !== state ) {
				card.style.display = 'none';
			} else {
				card.style.display = 'flex';
			}

			if ( state === 'coming-soon' && cardComingSoon !== '1' ) {
				card.style.display = 'none';
			} else if ( state === 'coming-soon' && cardComingSoon === '1' ) {
				card.style.display = 'flex';
			}
		});
	});
});

const retailerButtons = document.querySelectorAll('.btn-shop-retailer');
function handleClick(retailer) {
	// Plain JS method of setting Home Location
	localStorage.setItem('dutchie_retailer', JSON.stringify(retailer));
}
retailerButtons.forEach(function(button) {
	button.addEventListener('click', function() {
		const id = button.dataset.retailerId;
		const retailer = dutchie.retailers.find(function(retailer) {
			return retailer.id == id;
		});

		handleClick(retailer)
	});
})